<template functional>
  <b-nav underlines class="border-bottom">
    <slot></slot>
  </b-nav>
</template>

<script>
export default {
  name: 'Navbar'
}
</script>
